import { useDispatch, useSelector } from "react-redux";
import { MDBView } from "mdbreact";
import {
  formatScheduleLabel,
  SetPHYSICIAN,
  SetSCHED,
  TOGGLE_PATIENT_MODAL,
  SetFILTERED,
} from "../../../../services/redux/slices/diagnostics/clinic/appointments";
import { properFullname } from "../../../../services/utilities";
import { Search } from "../../../../components/searchables";
import { useState } from "react";

const getPhysicianDisplayName = (physician = {}) =>
  properFullname(
    physician?.fullName ||
      physician?.user?.fullName ||
      physician?.ghost?.fullName ||
      physician?.ghost,
  ) !== "-"
    ? properFullname(
        physician?.fullName ||
          physician?.user?.fullName ||
          physician?.ghost?.fullName ||
          physician?.ghost,
      )
    : physician?.displayName ||
      [
        physician?.user?.fullName?.fname ||
          physician?.fullName?.fname ||
          physician?.ghost?.fullName?.fname ||
          physician?.ghost?.fname,
        physician?.user?.fullName?.mname ||
          physician?.fullName?.mname ||
          physician?.ghost?.fullName?.mname ||
          physician?.ghost?.mname,
        physician?.user?.fullName?.lname ||
          physician?.fullName?.lname ||
          physician?.ghost?.fullName?.lname ||
          physician?.ghost?.lname,
        physician?.user?.fullName?.suffix ||
          physician?.fullName?.suffix ||
          physician?.ghost?.fullName?.suffix ||
          physician?.ghost?.suffix,
      ]
        .filter(Boolean)
        .join(" ")
        .trim() ||
      physician?.user?.email ||
      physician?.email ||
      physician?.name ||
      physician?.alias ||
      physician?.ghost?.alias ||
      "Unnamed physician";

const Header = () => {
  const { collections, physicians, scheds, activeSched, activePhysician } =
      useSelector(({ appointments }) => appointments),
    [lastSched, setLastSched] = useState(""),
    dispatch = useDispatch();

  return (
    <MDBView
      cascade
      className="gradient-card-header custom-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
    >
      <div className="d-flex justify-items-center" style={{ width: "20rem" }}>
        <div className="white-text mx-3 text-nowrap mt-0 d-flex align-items-center">
          <span className="mr-2">Physician:</span>
          <select
            className="form-control bg-light"
            style={{ padding: "0 5px", fontSize: ".8rem " }}
            value={activePhysician?._id}
            onChange={({ target }) => dispatch(SetPHYSICIAN(target.value))}
          >
            <option value="">All</option>
            {physicians.map((physician) => {
              const isExisting = physicians.some(({ _id }) => _id === physician._id);
              return (
                <option
                  key={physician?._id}
                  value={physician?._id}
                  disabled={!isExisting}
                  title={!isExisting && "No Clinic has been Register"}
                >
                  Dr. {getPhysicianDisplayName(physician)}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      {activePhysician?._id && (
        <div className="white-text mx-3 text-nowrap mt-0 d-flex align-items-center ml-n5">
          <span className="mr-2">Schedule:</span>
          <select
            className="form-control bg-light"
            value={activeSched}
            onChange={({ target }) => {
              dispatch(SetSCHED({ sched: target.value }));
            }}
          >
            <option value="">All</option>
            {scheds.map((sched) => (
              <option key={sched} value={sched}>
                {formatScheduleLabel(sched)}
              </option>
            ))}
          </select>
        </div>
      )}
      <Search
        setFiltered={(items) => {
          dispatch(SetFILTERED(items));
          dispatch(SetSCHED({ sched: "", isSearch: true }));
          setLastSched(activeSched);
        }}
        reset={() => {
          dispatch(SetSCHED({ sched: lastSched }));
        }}
        collections={collections}
        handleAdd={(searchValue) => dispatch(TOGGLE_PATIENT_MODAL(searchValue))}
        hideButton
      />
    </MDBView>
  );
};

export default Header;
